import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
	margin-top: 8px;
	margin-bottom: 8px;
`;

interface OptionProps {
	isMobile?: boolean;
}

export const Option = styled.button<OptionProps>`
	display: inline-flex;
	align-items: center;
	text-align: left;
	padding: 8px 20px 8px 16px;
	background-color: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 18px;
	font-family: inherit;
	font-size: ${({ isMobile }) => (isMobile ? '16px' : '13px')};
	font-weight: 500;
	line-height: 1.4;
	color: ${({ theme }) => theme.gray[900]};
	transition: background-color 0.15s ease, border-color 0.15s ease;
	user-select: none;
	align-self: flex-start;

	&:hover {
		background-color: ${({ theme }) => theme.gray[200]};
		border-color: ${({ theme }) => theme.blue[500]};
	}
`;
